<template>
    <div class="commend-view">
        <van-panel v-for="(item,index) in  commpendList" :key="index">
            <div class="commend-wrapper">
                <div class="img-view"><img :src="item.img"></div>
                <div class="detail-view">
                    <h4 class="title">{{item.title}}</h4>
                    <p class="desc">{{item.desc}}</p>
                    <div class="ketword">
                        <span>{{item.keyword1}}</span>
                        <span>{{item.keyword2}}</span>
                    </div>
                    <p class="price">${{item.price}}</p>
                </div>
            </div>
            <div slot="footer" class="footer">
                <span class="brand">{{item.brand}}</span>
                <span class="stand">{{item.standard}}</span>
                <button size="small" type="danger" class="similar">找相似</button>
            </div>
        </van-panel>
    </div>
</template>

<script>
    import { Panel, Button } from "vant";
    export default {
        name: "commendView",
        components: {
            [Panel.name]: Panel,
            [Button.name]: Button
        },
        data() {
            return {
                commpendList: []
            };
        },
        created() {
            var that = this;
            this.$ajax
                .get("/json/commend-list.json")
                .then(function (response) {
                    that.commpendList = response.data;
                });
        }
    };
</script>

<style lang="scss">
    .commend-view {
        margin-bottom: 10px;
        .van-panel__header {
            padding: 0;
        }
        .van-cell-group {
            margin-bottom: 10px;
        }
        .commend-wrapper {
            overflow: hidden;
            height: 180ppx;
            .img-view {
                width: 165px;
                float: left;
                text-align: center;
                margin-top: 40px;
                img {
                    width: 100%;
                }
            }
            .detail-view {
                width: 210px;
                float: left;
                margin-top: 9px;
                padding-right: 16px;
                box-sizing: border-box;
                .title {
                    font-size: 16px;
                    font-weight: 900;
                    line-height: 23px;
                    margin: 10px 0;
                }
                .desc {
                    font-size: 13px;
                    line-height: 18px;
                    color: #737373;
                }
                .ketword {
                    width: 116px;
                    height: 20px;
                    line-height: 20px;
                    margin: 10px 0;
                    font-size: 13px;
                    color: #d5b085;
                    text-align: center;
                    background-color: #f2f2f2;
                    margin-bottom: 12px;
                }
                .price {
                    color: red;
                    font-weight: 800;
                    font-size: 16px;
                }
            }
        }
        .footer {
            line-height: 20px;
            font-size: 12px;
            color: #808080;
            border-top: 0.3px solid #ccc;
            padding: 15px 10px;
            .brand {
                display: inline-block;
                margin-right: 102px;
            }
            .similar {
                font-size: 12px;
                border-color: #808080;
                background-color: #fff;
                float: right;
                height: 25px;
                line-height: 20px;
                border-radius: 15px;
                text-align: center;
            }
        }
    }
</style>